import React from 'react';
import { HomeContainer } from '../../containers';

const Home = () => <HomeContainer />;

export default Home;
